import tw from "twin.macro"
import styled from "@emotion/styled/macro"

import { StyledImage } from "../../../Styled/Image"

export const Section = styled.section`
  ${tw`grid gap-3.5 md:gap-7.5 grid-cols-1 grid-rows-1 mt-6 mb-10 md:my-16`}
  ${({ length }) => length === 2 && tw`grid-cols-2`}
  ${({ length }) => length === 3 && tw`grid-cols-3 grid-rows-2`}
  ${({ length }) => length === 4 && tw`grid-cols-2 grid-rows-2`}
`
export const Image = styled(StyledImage)`
  ${tw`col-span-1 row-span-1`}
  ${({ index, length }) => length === 3 && (!index ? tw`col-span-2 row-span-2` : tw`col-span-1 row-span-1`)}
`
